// extracted by mini-css-extract-plugin
export default {"filters":"AnimeSearch_filters__qKUvG","position":"AnimeSearch_position__2aD2J"};